import { Link } from "react-router-dom";
import { SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function Landing() {
  return (
    <div className="min-h-dvh">
      <header className="px-8 py-6 flex items-center justify-between">
        <div className="flex items-baseline gap-2">
          <span className="font-display text-2xl tracking-tight">CONNECT</span>
          <span className="label-eyebrow text-gold-glow">Intelligence OS</span>
        </div>
        <nav className="flex items-center gap-2">
          <SignedOut>
            <SignInButton mode="modal">
              <Button variant="ghost" size="sm">Sign in</Button>
            </SignInButton>
            <SignInButton mode="modal">
              <Button size="sm">Request access</Button>
            </SignInButton>
          </SignedOut>
          <SignedIn>
            <Button asChild size="sm">
              <Link to="/app">Enter</Link>
            </Button>
          </SignedIn>
        </nav>
      </header>

      <section className="max-w-5xl mx-auto px-8 pt-24 pb-32 animate-fade-up">
        <p className="label-eyebrow mb-6">A premium operating system</p>
        <h1 className="text-display-1 font-display max-w-3xl">
          Connective intelligence for
          <br />
          <span className="text-gold-glow">cultural advancement.</span>
        </h1>
        <p className="mt-8 max-w-2xl text-lg text-whisper leading-relaxed">
          CONNECT routes signals across the internet into contextual intelligence,
          premium communities, and real-world chapters. Built for brotherhood,
          sisterhood, leadership, and transformation.
        </p>
        <div className="mt-12 flex flex-wrap gap-3">
          <SignedOut>
            <SignInButton mode="modal">
              <Button size="lg">
                Enter the platform <ArrowUpRight className="size-4" />
              </Button>
            </SignInButton>
          </SignedOut>
          <SignedIn>
            <Button size="lg" asChild>
              <Link to="/app">
                Open intelligence <ArrowUpRight className="size-4" />
              </Link>
            </Button>
          </SignedIn>
          <Button variant="outline" size="lg" asChild>
            <a href="#ecosystems">Explore ecosystems</a>
          </Button>
        </div>
      </section>

      <section id="ecosystems" className="max-w-5xl mx-auto px-8 pb-32 grid md:grid-cols-2 gap-6">
        <EcosystemCard
          eyebrow="Ecosystem"
          name="B.E.A.M. Men"
          tagline="Brotherhood. Intelligence. Transformation."
        />
        <EcosystemCard
          eyebrow="Ecosystem"
          name="B.E.A.M. Women"
          tagline="Sisterhood. Intelligence. Transformation."
        />
      </section>

      <footer className="border-t border-veil/40 px-8 py-10 text-xs text-muted">
        CONNECT Intelligence OS — connective infrastructure for cultural advancement.
      </footer>
    </div>
  );
}

function EcosystemCard({
  eyebrow,
  name,
  tagline,
}: {
  eyebrow: string;
  name: string;
  tagline: string;
}) {
  return (
    <div className="panel p-8 group transition-colors hover:border-gold/30">
      <span className="label-eyebrow text-gold-glow">{eyebrow}</span>
      <h3 className="mt-3 text-display-2 font-display">{name}</h3>
      <p className="mt-3 text-whisper">{tagline}</p>
    </div>
  );
}
